import React, {useEffect} from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';

const MediaInput = ({partnershipId, name, label, options, isLoading, isSubmitting, load, multiple=false, allowNone=false, emptyOption=false, rules=[], ...props}) => {

  // load members on mount
  useEffect(() => {
    if (partnershipId) {
      load(partnershipId, 1, 50, 'created_at.desc');
    }
  }, [load, partnershipId]);

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label ? label : t('media_media')}
          rules={rules}
        >
          <Select
            mode={multiple ? "multiple" : null}
            showSearch
            optionFilterProp="children"
            disabled={isLoading || isSubmitting}
            loading={isLoading}
          > 
            {allowNone
              ? <Select.Option key={0} value={null}>{t('form_input_options_none')}</Select.Option>
              : null}
            {options.map(x => <Select.Option key={x.value} value={x.value}>{x.label}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default MediaInput;
